export { default as FullDescription } from './FullDescription';
